/*
 *  Bootstrap Nice Select Arabic (Saudi Arabia) Translation
 *  Author: Kevin Gostomski <kevingostomski2001@gmail.com> 
*/

const localisation = {
    locales: []
}

localisation.locales['ar-SA'] = localisation.locales['ar'] = {
    formatSearch() {
        return "يبحث...";
    },
    formatHelpForTagging() {
        return 'لإنشاء علامات خاصة ، ركز على حقل الإدخال ثم اضغط على "إدخال" أو "مفتاح المسافة" لإضافته إلى القائمة';
    }
}

export default localisation;